/** Interrupteur accessible (role switch) : « participe » d'une personne. */
export function Bascule({ actif, label, onChange, desactive = false }: { actif: boolean; label: string; onChange: (v: boolean) => void; desactive?: boolean }) {
  return (
    <button type="button" role="switch" aria-checked={actif} aria-label={label} className={`bascule${actif ? ' on' : ''}`} onClick={() => onChange(!actif)} disabled={desactive}>
      <i aria-hidden="true" />
    </button>
  );
}
